import type { FieldGroup } from "@/entities/form-metadata";
import { GroupType } from "@/entities/form-metadata";
import { Delimiter } from "@/shared/components/Delimiter";
import { EventGroup } from "./EventGroup";
import { FamilyMemberGroup } from "./FamilyMemberGroup";
import { HierarchicalGroup } from "./HierarchicalGroup";
import { NameGroup } from "./NameGroup";
import { OtherFieldsGroup } from "./OtherFieldsGroup/OtherFieldsGroup";
import { SpecialEvents } from "./SpecialEventsGroup/SpecialEventsGroup";

interface FieldGroupMapperProps {
    fieldGroup: FieldGroup;
}

const FieldGroupMapper = ({ fieldGroup }: FieldGroupMapperProps) => {
    if (fieldGroup.groupType === GroupType.FamilyMember) return <FamilyMemberGroup fieldGroup={fieldGroup} />;
    if (fieldGroup.groupType === GroupType.Event) return <EventGroup fieldGroup={fieldGroup} />;
    if (fieldGroup.groupType === GroupType.Name) return <NameGroup fieldGroup={fieldGroup} />;
    if (fieldGroup.groupType === GroupType.Hierarchical) return <HierarchicalGroup fieldGroup={fieldGroup} />;
    if (fieldGroup.groupType === GroupType.Special) return <SpecialEvents fieldGroup={fieldGroup} />;
    // @ts-ignore FIXME
    if (fieldGroup.groupType === GroupType.Other) return <OtherFieldsGroup fieldGroup={fieldGroup} />;

    return null;
};

interface FieldGroupRendererProps {
    fieldGroup: FieldGroup;
}

export const FieldGroupRenderer = ({ fieldGroup }: FieldGroupRendererProps) => (
    <>
        <div data-test-sfs-container-type="fieldGroup" data-test-sfs-group-type={fieldGroup.groupType}>
            <FieldGroupMapper fieldGroup={fieldGroup} />
        </div>
        {fieldGroup.features?.delimiter && <Delimiter />}
    </>
);
